import firebase, { database } from '@/plugins/firebase';
// Custom error class for soft-deleted users
export class SoftDeletedUserError extends Error {
    constructor() {
        super('USER_SOFT_DELETED');
        this.name = 'SoftDeletedUserError';
    }
}
export const UserModule = {
    namespaced: true,
    state: {
        logged: false,
        role: 0,
        userId: '',
    },
    mutations: {
        log(state, value) {
            state.logged = value;
        },
        role(state, value) {
            state.role = value;
        },
        userId(state, value) {
            state.userId = value;
        },
    },
    actions: {
        async auth(context, values) {
            const persistence = values.persist
                ? firebase.auth.Auth.Persistence.LOCAL
                : firebase.auth.Auth.Persistence.SESSION;
            await firebase.auth().setPersistence(persistence);
            const userCredential = await firebase
                .auth()
                .signInWithEmailAndPassword(values.email, values.password);
            // Check if user is soft-deleted before allowing login
            const userDoc = await database
                .collection('instructors')
                .doc(userCredential.user.uid)
                .get();
            if (userDoc.exists) {
                const userData = userDoc.data();
                if (userData && userData.deletedAt) {
                    // User is soft-deleted, sign out immediately and throw error
                    await firebase.auth().signOut();
                    throw new SoftDeletedUserError();
                }
            }
            context.commit('log', true);
        },
        async resetPassword(context, email) {
            await firebase.auth().sendPasswordResetEmail(email);
        },
        async login(context, user) {
            let role = (await user.getIdTokenResult()).claims.role;
            context.commit('userId', user.uid);
            context.commit('role', role);
            context.commit('log', true);
        },
        async logout(context) {
            await firebase.auth().signOut();
            context.commit('log', false);
            context.commit('userId', '');
            context.commit('role', 0);
        },
    },
    getters: {
        isLoggedIn: (state) => {
            return state.logged;
        },
        role: (state) => {
            return state.role;
        },
        userId: (state) => {
            return state.userId;
        },
        isAdmin: (state) => {
            return state.role >= 100;
        },
        isModerator: (state) => {
            return state.role >= 50;
        }
    },
};
